var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { LayerContext } from '../VectorLayer';
import ModifyInteraction from 'ol/interaction/Modify';

function ModifyImpl(_ref) {
  var map = _ref.map,
      layer = _ref.layer,
      onModifyStart = _ref.onModifyStart,
      onModifyEnd = _ref.onModifyEnd,
      props = _objectWithoutProperties(_ref, ['map', 'layer', 'onModifyStart', 'onModifyEnd']);

  var callbacks = useRef({});

  useEffect(function () {
    var modify = new ModifyInteraction(_extends({
      source: !props.features ? layer.getSource() : null,
      features: props.features
    }, props));
    map.addInteraction(modify);

    modify.on('modifystart', function (e) {
      var onModifyStart = callbacks.current.onModifyStart;

      onModifyStart && onModifyStart(e.features);
    });

    modify.on('modifyend', function (e) {
      var onModifyEnd = callbacks.current.onModifyEnd;

      onModifyEnd && onModifyEnd(e.features);
    });

    return function () {
      map.removeInteraction(modify);
    };
  }, [map, layer]);

  useEffect(function () {
    callbacks.current = { onModifyStart: onModifyStart, onModifyEnd: onModifyEnd };
  }, [onModifyStart, onModifyEnd]);

  return null;
}

/**
 *  OL modify interaction wrapper. Add modify control to VectorLayer
 *
 * Passed as a child of VectorLayer (or a source rendering a VectorLayer).
 *
 * Additional properties are passed on to ol/interaction/Modify.
 */
function Modify(_ref2) {
  var onModifyStart = _ref2.onModifyStart,
      onModifyEnd = _ref2.onModifyEnd,
      props = _objectWithoutProperties(_ref2, ['onModifyStart', 'onModifyEnd']);

  return React.createElement(
    LayerContext.Consumer,
    null,
    function (value) {
      return React.createElement(ModifyImpl, _extends({
        map: value.map,
        layer: value.layer,
        onModifyStart: onModifyStart,
        onModifyEnd: onModifyEnd
      }, props));
    }
  );
}

Modify.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Callback function. Triggered by ol event modifystart
   * @param {Array} features The features
   */
  onModifyStart: PropTypes.func,
  /**
   * Callback function. Triggered by ol event modifyend
   * @param {Array} features The features after modification
   */
  onModifyEnd: PropTypes.func
} : {};

export default Modify;